<template>
  <div v-show="visible">
    <div class="popup_wrap file_upload">
      <div class="popup_title">
        <p><span id="node_title">첨부파일</span></p>
        <a class="_command[CmmComm.closeLayer]">
          <div id="popup_close" class="btn_close" title="Close" @click="close"><div class="btn_close_box"><span></span><span></span></div></div>
        </a>
      </div><!-- //popup_title -->
      <div class="popup_content1">
        <div v-if="getExperimentResultMode!='readOnly'" class="file-drop-zone">
            <div class="file-drop-zone-btn-upload">
                <input type="file" id="atch_file_id" name="atch_file_id" class="input-file-upload" style="display: none;" multiple ref="fileInput" @change="addFile($event, 'file')">
                <label class="btn_basic2 btn_type1 ce-file-upload" @click="triggerFileInput">파일 업로드</label>
            </div>
            <div class="text_center">
                10GB 이상 파일은 업로드가 불가능합니다.<br/>
                등록 가능한 파일은 다음과 같습니다.<br/>
                <span style="color: red; font-weight: bold">[
                {{availableExtension.size == 0? '전체허용' : Array.from(availableExtension).join(', ')}}
                ]</span><br/>
                추가 확장자 요청의 경우 관리자에게 문의해주세요.
            </div>
        </div>
        <br/><br/>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" class="board_view_area goods_img" id="t_file" >
            <colgroup>
                <col width="70%">
                <col width="20%">
                <col width="10%">
            </colgroup>
            <thead>
            <tr>
                <th>파일명</th>
                <th>크기</th>
                <th>삭제</th>
            </tr>
            </thead>
            <tbody>
              <tr v-for="(file,index) in fileArray.filter(file => file.active)" :key="file.fileId">
                <td>
                  <span style="display: inline-block" class="file_item" @click="downloadFile(file.fileId,file.originalFileName)">
                    {{file.originalFileName.length > 25 ? file.originalFileName.slice(0,25)+"..." : file.originalFileName}}
                  </span>
                  <br>
                  <video v-if="file.mimeType == 'video/mp4'" id="videoPlayer" controls preload="metadata" style="max-width: 100%; height: auto;">
                    <source :src="file.url" type="video/mp4">
                    브라우저가 영상을 지원하지 않습니다.
                  </video>
<!--                  <video v-if="videoUrls[file.fileId]" :src="videoUrls[file.fileId]" controls width="99%">
                    Your browser does not support the video tag.
                  </video>-->
                </td>
                <td style="vertical-align: middle">
                 {{formatSize(file.size)}}
                </td>
                <td style="vertical-align: middle">
                  <a v-if="getExperimentResultMode!='readOnly'" class="btn_node_delete" @click="deleteFileMapping(file.fileId)">&nbsp</a>
                </td>
              </tr>
            </tbody>
        </table>
      </div>
      <div class="popup_footer">
        <a v-if="getExperimentResultMode!='readOnly'" class="btn_type1" @click="saveMapping">저장</a>
        <a class="btn_type3" @click="close">닫기</a>
      </div>
    </div>
    <div class="mask_wrap" style="display:block;"></div>
    <Loading :visible="loading" type="fixed"/>
    <!-- Progress Overlay -->
    <div v-if="uploadProgress > 0 && uploadProgress < 100" class="progress-overlay">
      <div class="progress-container">
        <div class="progress-bar">
          <div class="progress-fill" :style="{width: uploadProgress + '%'}"></div>
        </div>
        <div class="progress-text">{{ uploadProgress }}% 업로드 중...</div>
      </div>
    </div>
  </div>
</template>

<script>
import Loading from '@common/loading.vue';
import {createNamespacedHelpers} from 'vuex';
import axios from "@/plugins/axios";
import {PROPERTY_TYPE} from "@/util/HubHandsonTable";
import * as tus from 'tus-js-client';
import getToken from "@/plugins/wApi/lib/getToken.ts";

const Hub = createNamespacedHelpers('Hub');

export default {
  data() {
    return {
      loading : null,
      visible : false,
      fileArray : [],
      availableExtension : new Set(),
      imageExtension : ['png','jpeg','gif','svg','jpg'],
      uploadFlag : false,
      maxVersion : 0,
      videoUrls : [],
      PROPERTY_TYPE : PROPERTY_TYPE,
      uploadProgress: 0,
      currentUpload: null,
    }
  },
  components: {
    Loading,
  },
  computed: {
    ...Hub.mapGetters(
      ['hotInstance','getFileUploadObj','getExperimentResultMode']),
  },
  watch: {
    getFileUploadObj: {
      deep : true,
      async handler (value) {
        if(value.fileUploadPopFlag === true && typeof value.fileMappingInfo == 'object'){
          this.show();
          await this.initiallize();
        }else if(value.fileUploadPopFlag === false){
          this.availableExtension = new Set();
          this.visible = false;
          this.fileArray = [];
          this.uploadFlag = false;
          this.maxVersion = 0;
          Object.keys(this.videoUrls).forEach(fileId => {
            URL.revokeObjectURL(this.videoUrls[fileId]);
          });
          this.videoUrls = [];
          this.uploadProgress = 0;
        }
      }
    },
  },
  beforeDestroy() {
    Object.keys(this.videoUrls).forEach(fileId => {
      URL.revokeObjectURL(this.videoUrls[fileId]);
    });
    if (this.currentUpload) {
      this.currentUpload.abort();
    }
  },
  async mounted() {

  },
  methods: {
    ...Hub.mapMutations([
        'setFileUploadObj'
    ]),
    async initiallize(){
        try {
          this.loading = true;
          const res = await this.$wApi.file.getFileExtension({});
          this.availableExtension = new Set([...this.availableExtension, ...res]);

          if(this.getFileUploadObj.fileMappingInfo.type == this.PROPERTY_TYPE.IMAGE.value){
            this.availableExtension = new Set([...this.availableExtension, ...this.imageExtension]);
          }

          const response = await this.$wApi.file.getFileMapping({
            mappingKey : this.getFileUploadObj.fileMappingInfo.mappingKey,
          });
          if(!response?.error){
            response.forEach(mapping => {
              const version = mapping.mappingTable.replace("handsontable_","")*1;
              this.maxVersion = Math.max(this.maxVersion,version);
              if(mapping.active) {
                if(mapping.mimeType == 'video/mp4'){
                  mapping.url = axios.getUri()+'/v1/file/stream/'+mapping.fileId;
                }
                this.fileArray.push(mapping);
              }
            })
          }
        }catch (e){
          alert(e.message);
          this.loading = false;
        }finally {
          this.loading = false;
        }
    },
    triggerFileInput(){
      this.$refs.fileInput.value = '';
      this.$refs.fileInput.click();
    },
    async addFile(e, key = "file") {
      if(this.fileArray.filter(item => item.active).length >= 1 || e.target.files.length > 1){
        alert("cell당 파일은 한개만 적용할 수 있습니다.")
        return;
      }
      
      const files = Array.from(e.target.files); 

      try {
        this.loading = true;
        this.uploadProgress = 0;
        
        for (const file of files) { 
          if (file.size > 10737418240) {
            alert("파일 크기가 10GB를 초과합니다. 10GB 이하의 파일만 업로드 가능합니다.");
            e.target.value = '';
            return;
          }
          //추후 파일 제한시 this.getFileUploadObj.fileMappingInfo.type == 'IMAGE' 제거
          if(!this.availableExtension.has(file.name.split('.').pop().toLowerCase()) && this.getFileUploadObj.fileMappingInfo.type == this.PROPERTY_TYPE.IMAGE.value){
            alert('허용된 확장자가 아닙니다.');
            e.target.value = '';
            return;
          }

          // TUS 업로드
          const uploadedFile = await this.uploadWithTus(file);
          
          this.fileArray.push({
            fileMappingId : null,
            fileId : uploadedFile.id,
            url : uploadedFile.url,
            originalFileName : uploadedFile.originalFileName,
            fileName : uploadedFile.fileName,
            size : uploadedFile.size,
            mimeType : uploadedFile.mimeType,
            active : true
          });
          this.uploadFlag = true;
        }
      } catch (e) {
        console.error('Upload Error:', e);
        alert('upload Error: ' + e.message)
        this.loading = false;
      }finally {
        this.loading = false;
        this.uploadProgress = 0;
      }
    },
    uploadWithTus(file) {
      return new Promise((resolve, reject) => {
    
        const upload = new tus.Upload(file, {
          endpoint: axios.getUri() + '/v1/file/tus',
          retryDelays: [0, 1000, 3000, 5000, 10000, 20000],
          chunkSize: 50 * 1024 * 1024,
          metadata: {
            filename: file.name,
            filetype: file.type
          },
          headers: getToken(),
          uploadDataDuringCreation: false,
          removeFingerprintOnSuccess: true,
          
          // onAfterResponse 제거
          
          onError: (error) => {
            console.error('TUS Upload failed:', error);
            reject(error);
          },
          
          onProgress: (bytesUploaded, bytesTotal) => {
            this.uploadProgress = Math.round((bytesUploaded / bytesTotal) * 100);
            console.log(`Upload progress: ${this.uploadProgress}%`);
          },
          
          onSuccess: async () => {
            try {
              console.log('TUS Upload completed');
              const uploadUrl = upload.url;
              const fileId = uploadUrl.substring(uploadUrl.lastIndexOf('/') + 1);
              
              const response = await this.$wApi.file.getTusFileInfo({ fileId });
              resolve(response);
            } catch (error) {
              console.error('Failed to get file info:', error);
              reject(error);
            }
          }
        });
    
        this.currentUpload = upload;
        upload.start();
      });
    },
    async saveMapping() {
      if(!this.uploadFlag){
        //변경사항이 존재할 경우만 파일매핑 업데이트
        alert("파일이 저장됐습니다.");
        this.close();
        return;
      }
      try {
        this.loading = true;
        //console.log('this.fileArray',this.fileArray);
        const data = this.fileArray.map((file,index) => {
          return {
            fileMappingId : file.fileMappingId,
            fileId : file.fileId,
            sn : index,
            active : file.active,
            mappingTable : this.getFileUploadObj.fileMappingInfo.mappingTable+"_"+(this.maxVersion+1),
            mappingKey : this.getFileUploadObj.fileMappingInfo.mappingKey
          };
        });
        //console.log('data',data);
        if(data.length == 0) {
          this.close();
          return;
        }
        const response = await this.$wApi.file.saveFileMapping(data);
        if(!response.error){
          let uploadFileArray = this.fileArray.filter(file => file.active);
          let fileName = '';
          if(uploadFileArray.length == 1){
            fileName = uploadFileArray[0].originalFileName
          }else if(uploadFileArray.length > 1){
            fileName = uploadFileArray[0].originalFileName +"외 "+ (uploadFileArray.length-1)+"건"
          }
          this.hotInstance.setDataAtCell(this.getFileUploadObj.fileMappingInfo.row, this.getFileUploadObj.fileMappingInfo.col, fileName);
          this.close();
          alert("파일이 저장됐습니다.")
        }
      } catch (e) {
        alert('fileMapping Error!')
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async downloadFile(fileId,originalFileName) {
      try {
        this.loading = true;
        const response = await this.$wApi.file.download({fileId: fileId},null, { responseType: 'blob' });
        const url = window.URL.createObjectURL(response.data);
        const downloadLink = document.createElement('a');
        downloadLink.href = url;
        downloadLink.download = originalFileName;
        document.body.appendChild(downloadLink);
        downloadLink.click();
        downloadLink.remove();
        window.URL.revokeObjectURL(url);
      } catch (e) {
        console.log('download Error!',e);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    async blobVideo(fileId) {
      try {
        this.loading = true;
        if (this.videoUrls[fileId]) {
          // 이미 다운로드된 영상이 있으면 다시 요청하지 않음
          return;
        }
        const response = await this.$wApi.file.blobVideo({fileId: fileId},null, { responseType: 'blob' });

        if (this.videoUrls[fileId]) {
          URL.revokeObjectURL(this.videoUrls[fileId]);
        }

        // Vue.set을 사용하여 반응형 데이터 변경 감지
        this.$set(this.videoUrls, fileId, window.URL.createObjectURL(response.data));

      } catch (e) {
        console.log('streaming Error!',e);
        this.loading = false;
      } finally {
        this.loading = false;
      }
    },
    deleteFileMapping(fileId){
      this.fileArray.find(file => file.fileId == fileId).active = false;
      this.uploadFlag = true;
    },
    formatSize(value) {
      if (!value || isNaN(value)) return '0 B';

      const size = parseInt(value, 10);
      if (size < 1024) {
        return `${size} B`;
      } else if (size < 1024 * 1024) {
        return `${(size / 1024).toFixed(2)} KB`;
      } else if (size < 1024 * 1024 * 1024) {
        return `${(size / (1024 * 1024)).toFixed(2)} MB`;
      } else {
        return `${(size / (1024 * 1024 * 1024)).toFixed(2)} GB`;
      }
    },
    show() {
      this.fileArray = [];
      this.visible = true;
    },
    close() {
      if (this.currentUpload) {
        this.currentUpload.abort();
        this.currentUpload = null;
      }
      this.setFileUploadObj({
        openFlag: false,
        dataObj: {}
      });
      Object.keys(this.videoUrls).forEach(fileId => {
        URL.revokeObjectURL(this.videoUrls[fileId]);
      });
      this.uploadProgress = 0;
    },
  }
}
</script>

<style lang="scss">
  @import "@/style/new/css/cyl.common.css";
  .file_upload  {display:block;position:fixed; width:550px;height:500px;  left:50%;top:50%;transform:translate(-50%,-50%); z-index:999; box-shadow:5px 5px 20px 0px rgba(0,0,0,0.2);}
  @media screen and (max-width: 1250px) {
    .file_upload {width:95%;}
  }

  .progress-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 10000;
  }

  .progress-container {
    background: white;
    padding: 20px;
    border-radius: 8px;
    box-shadow: 0 2px 10px rgba(0,0,0,0.2);
    width: 300px;
    text-align: center;
  }

  .progress-bar {
    width: 100%;
    height: 25px;
    background-color: #f0f0f0;
    border-radius: 12px;
    overflow: hidden;
    box-shadow: inset 0 1px 3px rgba(0, 0, 0, 0.2);
  }

  .progress-fill {
    height: 100%;
    background: linear-gradient(90deg, #4CAF50 0%, #45a049 100%);
    transition: width 0.3s ease;
    border-radius: 12px;
  }

  .progress-text {
    margin-top: 8px;
    font-weight: bold;
    color: #333;
  }
</style>